import { ModalDialog } from './ui/ModalDialog'
import { PrimaryButton } from './ui'

interface EmailVerificationRequiredModalProps {
  open: boolean
  onClose: () => void
}

/**
 * Shown when Auth0 requires email verification before the user can sign in.
 */
export default function EmailVerificationRequiredModal({ open, onClose }: EmailVerificationRequiredModalProps) {
  return (
    <ModalDialog
      open={open}
      onClose={onClose}
      title="Confirm your email address"
      footer={
        <PrimaryButton type="button" onClick={onClose} fullWidth>
          OK
        </PrimaryButton>
      }
    >
      <p className="m-0 font-body text-md leading-md text-text-tertiary-600">
        We sent a confirmation link to your email when you registered. Please open that email and click the
        confirmation link, then return here and sign in.
      </p>
      <p className="mb-0 mt-4 font-body text-sm leading-sm text-text-tertiary-600">
        If you do not see the email, check your spam or junk folder.
      </p>
    </ModalDialog>
  )
}
